package org.dronda.app.web.ui.eventdetail

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.toAttrs
import org.dronda.app.web.Loader
import org.dronda.app.web.ui.components.AppColors
import org.dronda.app.web.ui.components.Badge
import org.dronda.app.web.ui.components.Card
import org.dronda.app.web.ui.components.PageColumn
import org.dronda.app.web.ui.components.StyledButton
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun EventDetailScreen(
    viewModel: EventDetailViewModel,
    onWishlistClick: (String) -> Unit,
    onAdminClick: () -> Unit,
) {
    val uiState by viewModel.uiState.collectAsState()

    PageColumn {
        when (val state = uiState) {
            is EventDetailViewModel.UiState.Loading -> {
                Loader()
            }
            is EventDetailViewModel.UiState.Success -> {
                val event = state.event
                Row(
                    modifier = Modifier.fillMaxWidth().gap(0.5.cssRem).flexWrap(FlexWrap.Wrap),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    Row(Modifier.gap(0.75.cssRem), verticalAlignment = Alignment.CenterVertically) {
                        H1(Modifier.fontWeight(FontWeight.Light).toAttrs()) {
                            Text(event.title)
                        }
                        event.modeBadge?.let { Badge(it) }
                    }
                    if (event.isAdmin) {
                        StyledButton("⚙ Admin", onClick = { onAdminClick() })
                    }
                }
                P(Modifier.color(AppColors.muted).toAttrs()) { Text(event.subtitle) }

                event.santaBanner?.let { banner -> SantaBannerCard(banner, onWishlistClick) }

                H2 { Text("Everyone") }

                Column(
                    modifier = Modifier.fillMaxWidth(),
                    verticalArrangement = Arrangement.spacedBy(0.5.cssRem)
                ) {
                    event.wishlists.forEach { wishlist ->
                        Card(onClick = { onWishlistClick(wishlist.id) }) {
                            H3(Modifier.fontWeight(FontWeight.Normal).toAttrs()) {
                                Text(wishlist.title)
                            }
                            Text(wishlist.subtitle)
                        }
                    }
                }
            }
            is EventDetailViewModel.UiState.Error -> {
                Text(state.message)
            }
        }
    }
}

@Composable
private fun SantaBannerCard(
    banner: EventDetailViewModel.SantaBanner,
    onWishlistClick: (String) -> Unit,
) {
    val wishlistId = banner.wishlistId
    Card(
        modifier = Modifier
            .backgroundColor(if (wishlistId != null) AppColors.accentSurface else AppColors.subtleSurface)
            .border(2.px, LineStyle.Solid, if (wishlistId != null) AppColors.accent else AppColors.subtleSurface),
        onClick = wishlistId?.let { { onWishlistClick(it) } },
    ) {
        Row(
            Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Column {
                H3(Modifier.fontWeight(FontWeight.Normal).toAttrs()) { Text(banner.title) }
                banner.body?.let { P(Modifier.color(AppColors.muted).toAttrs()) { Text(it) } }
            }
            if (wishlistId != null) {
                Text("View ▶")
            }
        }
    }
}
